import { MessageCircle } from 'lucide-react';
import { useSearchParams, Link } from 'react-router-dom';
import { ChatPopup, LatestConversation } from './ChatPopup';
import { timeAgo } from '../../utils/helpers';

const CONVERSATION_PARAM = 'conversation';

export const AppointmentConversationPanel = ({
  latestConversation,
}: {
  latestConversation?: LatestConversation;
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const open = searchParams.get(CONVERSATION_PARAM) === latestConversation?.encodedId;

  if (!latestConversation) return null;

  const closeChat = () =>
    setSearchParams((prev) => { prev.delete(CONVERSATION_PARAM); return prev; });

  return (
    <>
      <Link
        to={`?${CONVERSATION_PARAM}=${latestConversation.encodedId}`}
        className="w-full flex items-center gap-3 bg-white border border-gray-200 rounded-xl px-4 py-3.5 hover:border-teamcare-blue/50 hover:shadow-sm transition-all group text-left"
      >
        <div className="w-8 h-8 rounded-lg bg-teamcare-blue/10 flex items-center justify-center group-hover:bg-teamcare-blue/20 transition-colors flex-shrink-0">
          <MessageCircle size={16} className="text-teamcare-blue" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between">
            <p className="text-sm font-semibold text-secondary-900">Messages</p>
            {latestConversation.lastMessage?.time && (
              <span className="text-xs text-secondary-400 flex-shrink-0 ml-2">{timeAgo(latestConversation.lastMessage.time)}</span>
            )}
          </div>
          {latestConversation.lastMessage ? (
            <p className="text-xs text-secondary-500 mt-0.5 truncate">
              {latestConversation.lastMessage.fromPatient && (
                <span className="font-bold text-secondary-700">You: </span>
              )}
              {latestConversation.lastMessage.content}
            </p>
          ) : (
            <p className="text-[11px] text-secondary-400 mt-0.5 truncate">{latestConversation.title}</p>
          )}
        </div>
      </Link>

      {open && <ChatPopup conversation={latestConversation} onClose={closeChat} />}
    </>
  );
};
